import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { getDataLayer } from "../trackingHelper";

export default function checkoutCartTracking(cart: CartModel) {
    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }
    const dataLayerProducts: any[] = [];
    cart?.cartLines?.forEach(cartLine => {
        const qtyOnHand = cartLine?.qtyOnHand ?? 0;
        // Condition to show stock as "DirectShip" when total qty<=0 and isDirectShipFromManufacturer is true
        const availabilityMessage = Number(qtyOnHand) > 0
            ? "In Stock"
            : cartLine?.properties?.isDirectShipFromManufacturer?.toLowerCase() === "true"
                ? "DirectShip" : "Out Of Stock";
        const hazardousProduct = cartLine?.properties?.isHazardousGood.toLowerCase() === 'true' ? "Yes" : "";
        const eventData = {
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            price: cartLine?.pricing?.actualPrice,
            quantity: cartLine.qtyOrdered,
            category: cartLine?.properties?.cartlineCategoryName,
            list: cartLine?.properties?.productSourceActionField || "",
            listid: cartLine?.properties?.listIdField || "",
            position: cartLine?.properties?.productListPosition || "",
            stock: availabilityMessage,
            brand: cartLine?.properties?.cartLineBrandName,
            condition: cartLine?.properties?.cartLineCondition,
            vendorstockqty: cartLine?.qtyOnHand,
            Hazardous: hazardousProduct,
        };
        dataLayerProducts.push(eventData);
    });
    let latestCartCheckoutEvent = null;
    for (let i = dataLayer.length - 1; i >= 0; i--) {
        if (dataLayer[i]?.event) {
            latestCartCheckoutEvent = dataLayer[i].event;
            break;
        }
    }
    if (latestCartCheckoutEvent && latestCartCheckoutEvent.event === 'checkout' && latestCartCheckoutEvent?.ecommerce?.step === 1) {
        latestCartCheckoutEvent?.ecommerce?.detail?.products?.pop();
        latestCartCheckoutEvent?.ecommerce?.detail?.products.push({ dataLayerProducts });
    }
    else {
        const data = {
            'checkout': {
                'actionField': { 'step': 1, 'option': 'proceed to checkout', 'action': 'checkout' },
                'products': dataLayerProducts,
                'cartId': cart?.orderNumber
            }
        };
        const ecommerceObj = { 'event': 'checkout', ecommerce: data };
        dataLayer.push({ ecommerce: null });
        dataLayer.push(ecommerceObj);
    }
};